<template>
  <div id="group-create-details-tab">
    <div class="vx-col w-full">
      <div class="vx-row ">
        <div class="vx-col lg:w-1/3 sm:w-1/1 w-full mb-2 ">
          <vs-input class="w-full" label-placeholder="Group Name" v-model="dataLocal.group_name" @change="groupUpdateData"/>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2 ">
          <vs-select class="w-full mt-5" placeholder="Group Status" v-model="dataLocal.group_status">
            <vs-select-item :key="index" :value="option" :text="option.charAt(0).toUpperCase() + option.slice(1)" v-for="(option,index) in status_options"/>
          </vs-select>
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mb-2 ">
          <div class="flex items-center justify-between mt-3">
            <h3>Group Color</h3>
            <v-swatches v-model="dataLocal.group_color" :swatches="swatches" row-length="5" show-fallback popover-x="left"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full mt-2">
          <vs-textarea  label="Group Description" counter="400" :counter-danger.sync="group_description_counter" height="100px" v-model="dataLocal.group_description" @change="groupUpdateData"/>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" type="filled" class="mb-2 mr-2"
                     @click="submitData">Update Group
          </vs-button>
          <vs-button color="warning" type="border" class="mb-2 ml-2"
                     @click="resetData">Reset
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      group_description_counter: null,

      swatches: [
        ['#55efc4', '#81ecec', '#74b9ff', '#a29bfe', '#dfe6e9'],
        ['#00b894', '#00cec9', '#0984e3', '#6c5ce7', '#b2bec3'],
        ['#ffeaa7', '#fab1a0', '#ff7675', '#fd79a8', '#636e72'],
        ['#fdcb6e', '#e17055', '#d63031', '#e84393', '#636e72']
      ],

      status_options: [
        'active',
        'hidden',
        'disabled'
      ]

    }
  },
  components: {
    VSwatches
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    groupUpdateData () {
      this.$emit('update_group_data', this.dataLocal)
    },
    submitData () {
      this.$emit('insert_group_data', this.dataLocal)
    },
    resetData () {
      this.dataLocal =  {group_name: undefined, group_description: undefined, group_status: undefined, group_code : undefined}
      this.groupUpdateData()
    }
  }
}
</script>

<style scoped>

</style>
